export const LOAD_LABELS = "LOAD_LABELS";
